<app-page-title [title]="title"></app-page-title>

<div class="section">
  <button class="back" [routerLink]="['/permissoes']">Voltar</button>
</div>
